import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-insightful-chat-panel-form',
  imports: [FormsModule],
  templateUrl: './insightful-chat-panel-form.component.html',
  styleUrl: './insightful-chat-panel-form.component.scss'
})
export class InsightfulChatPanelFormComponent {
  @Input() medium: string = '';
  chatQuery: string = '';

  constructor(private router: Router) {}

  onSubmit(event: Event) {
    event.preventDefault();
    const query = this.chatQuery?.trim();
    if (query) {
      const url = this.router.serializeUrl(
        this.router.createUrlTree(['/askIC'], {
          queryParams: {
            q: query,
            nav_source: 'platform',
            nav_medium: this.medium,
            nav_campaign: 'ic_container',
          }
        })
      );
      window.open(url, '_blank');
      this.chatQuery = '';
    }
  }
}
